import React, { FC, useEffect, useMemo, useState } from "react";
import { OpenList } from "../svgs/OpenList";
import { PrevNextButton } from "../svgs";
import { getDaysOfInterval, useViewModel, weekDaysShort } from "../../utils";
import { observer } from "mobx-react-lite";
import { MiniCalendarDay } from "./MiniCalendarDay";
import { MiniCalendarService } from "../../utils/services/MiniCalendarService";
import '../../styles/components/calendarPopup.scss';

export const CalendarPopup: FC = observer(() => {
  const calendarService = useViewModel(MiniCalendarService);

  const [isOpen, setOpen] = useState(false);
  const switchPopup = () => setOpen((prev) => !prev);
  const selectDate = (date: Date) => {
    calendarService.selectDate(date);
    setOpen(false);
  }

  const startDate = calendarService.startInterval;
  const dates = useMemo(() => getDaysOfInterval(startDate, 'month'), [startDate]);
  
  useEffect(() => calendarService.getMeetingColors(), [calendarService.startInterval]);
  
  return (
    <>
      <div className="calendar-settings-m" onClick={switchPopup}>
        <span className="calendar-title">{calendarService.currentMonth}</span>
        <OpenList isOpen={isOpen} />
      </div>

      {isOpen && (
        <div className="calendar-popup">
          <div className="calendar-popup-title">
            <PrevNextButton
              onClick={calendarService.prevMonth} 
              divClassName="month-control-button"
            />
            <span className="calendar-title">{calendarService.currentMonth}</span>
            <PrevNextButton 
              isNext
              onClick={calendarService.nextMonth} 
              divClassName="month-control-button right"  
            />
            <p 
              className="today-popup"
              onClick={calendarService.toCurrentMonth}
            >
              Сегодня
            </p>
          </div>
          <div className="mini-calendar">
            <div className='day-titles'>
              {weekDaysShort.map((day: string) => (
                <span
                  key={day}
                  className='day'
                >
                  {day}
                </span>
              ))}
            </div>
            <div className='calendar-days'>
              {dates.map((date: Date) => (
                <MiniCalendarDay
                  key={+date}
                  filteredMeetings={calendarService.calendarMeetingsColor} 
                  onClick={selectDate} 
                  date={date}
                  startDate={startDate}
                  today={calendarService.today}
                  selectedDate={calendarService.selectedDate}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  )
});
